import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { LDFlagSet } from 'launchdarkly-js-sdk-common';

export const useFeatureFlagsStore = defineStore('feature-flags', () => {
  const resolveContext = ref<(ldFlagSet: LDFlagSet) => void>();

  const contextPromise = ref(new Promise<LDFlagSet>((resolve) => {
    resolveContext.value = resolve;
  }));

  return {
    resolveContext,
    contextPromise,
  };
});
